import TimeRowShell from '../timeRowShell/TimeRowShell';
import BreakCard from '../breakCard/BreakCard';
import * as css from './BreakCardRow.css';
import {TTimetableItem} from '../../../../redux/timetable/timetable.type';

interface BreakCardRowProps {
    time: string;
    breakItem: TTimetableItem;
    onEdit: () => void;
}

function BreakCardRow({time, breakItem, onEdit}: BreakCardRowProps) {
    return (
        <TimeRowShell time={time}>
            <css.breakArea>
                <BreakCard breakItem={breakItem} onEdit={onEdit} />
            </css.breakArea>
        </TimeRowShell>
    );
}

export default BreakCardRow;
